import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";

/*
import { IssuesList } from "../views/issues/IssuesList";
import { ItemsList } from "../views/items/ItemsList";
import { RoomsList } from "../views/rooms/RoomsList";
*/

//RM
import Item from "../views/items/Item";
import Issue from "../views/issues/Issue";
import Room from "../views/rooms/Room";
import Dining from "../views/dinings/DiningV2";
//import Community from '../views/community/Community'
import Community from '../views/community/CommunityV2'
import Repairs from "../views/repairs/RepairsV2";
import Activities from '../views/activities/ActivitiesV2'
import Users from '../views/users/Users.js'
import Dashboard from '../views/dashboard/DashboardV2'
import Scheduler from '../views/scheduler/Scheduler'
import VersionPage from "../views/version/VersionPage";
//import Boards from "../views/boards/Boards";
import HelpTile from "../views/helpTile/HelpTiles";
import DiagnosticReport from "../views/diagnosticReport/DiagnosticReport";

export const DashboardRoute = ({ worxHubActive }) => {

  const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

  return (
    <div>
      <Switch>
        <Route exact path="/items" component={Item} />
        <Route exact path="/issues" component={Issue} />
        <Route exact path="/dinings" component={Dining} />
        <Route exact path="/community" component={Community} />
        <Route exact path="/activities" component={Activities} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/scheduler" component={Scheduler} />
        <Route exact path="/rooms" component={Room} />
        <Route exact path="/diagnosticReport" component={DiagnosticReport} />
        {/*<Route exact path="/boards" component={Boards} />*/}

        {
          (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0 && !worxHubActive) ?
            <Route exact path="/repairs" component={Repairs} />
            :
            undefined
        }

        {/* Routes should not be inside a fragment or other element should be in the root of the switch */}
        {
          //IsSuperAdmin
          isSuperAdmin ?
            <Route exact path="/users" component={Users} />
            :
            undefined
        }
        {
          //IsSuperAdmin
          isSuperAdmin ?
            <Route exact path="/version" component={VersionPage} />
            :
            undefined
        }

{
          //IsSuperAdmin
          isSuperAdmin ?
            <Route exact path="/helptiles" component={HelpTile} />
            :
            undefined
        }

        {/* this  route should be the last one on the switch, is the default route*/}
        <Redirect to="/dashboard" />

      </Switch>
    </div>
  );
};

